<script type="text/jsx">
import { mapGetters } from 'vuex'
export default {
  name: 'SectionBrands',
  computed: {
    ...mapGetters({
      content: 'home/getContent'
    })
  },
  render () {
    return (
      <section class="brands">
        { this.content.lang_strings && <h2>
          { this.content.lang_strings.brands_title.replace('%s', this.content.brands.length) }
        </h2>}
        {this.content.brands && <ul class="brands__list">
          {this.content.brands.slice(0, 6).map(brand => {
            return <li class="brands__item" key={brand.id}>
              <img src={brand.image} alt={brand.name} />
            </li>
          })}
          <router-link class="brands__more" to="brands">
            { (this.content.lang_strings && this.content.brands.length > 6)
              ? this.content.lang_strings.brands_more_button.replace('%s', this.content.brands.length - 6)
              : 'Посмотреть все'}
          </router-link>
        </ul>}
        <transition name="brand">
          <router-view />
        </transition>
      </section>
    )
  }
}
</script>

<style scoped>
  .brand-enter-active, .brand-leave-active {
    transition: all .3s cubic-bezier(0.645,  0.045, 0.355, 1.000);
  }
  .brand-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */ {
    transform: translateX(100%);
  }
  .brand-enter {
    transform: translateX(100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/Other/SectionBrands.vue